import {useState} from 'react';
import {UseFileUpload} from '../../firebase/hooks/useFileUpload';
import {usePublicUserFileUpload} from './usePublicUserFileUpload';

export function useAvatarUpload(userId: string, fileExtension: string): UseFileUpload {
  const [filename] = useState(() => `avatar_${Date.now()}.${fileExtension}`);
  return usePublicUserFileUpload(userId, filename);
}
